import {TextField} from "@mui/material";
import React from "react";

const CommonTextBox = ({label, value, setValue, required, disabled, error, helperText, type, maxLength, name}) => {
    return (
        <TextField
            label={label}
            size="small"
            fullWidth
            required={required}
            disabled={disabled}
            name={name}
            value={value || ''}
            onChange={(event) => {
                setValue(event.target.value);
            }}
            error={error}
            helperText={helperText}
            inputProps={{
                maxLength: maxLength,
              }}
            InputProps={
                disabled && {
                    style: {
                        color: 'black !important',
                        backgroundColor: 'hsl(0, 0%, 95%)',
                    },
                }
            }
            type={type}
        />
    );
};

export default CommonTextBox;
